module.exports = function ($) {
    return {
        init: function () {
            // Append a class to the containers of all full width grid row to allow the padding to stretch to the eddge of the page
			
            $(".umb-grid > .grid-section > div > .container > .row").each(function () {
                // Wrap any rows with multple columns in a page container
                $(" > .column:not(.col-md-12) > div", this).each(function () {
                    $(this).parents('.container').addClass("container--centered");
                });
                // Wrap any submodules in a full width row in a page container
				$(" > .column.col-md-12 > div > aside div[class$='__container']", this).each(function () {

					if (!$(".umb-grid").hasClass("articleHolder") && !$(this).hasClass("faqList__container"))
					{
						$(this).addClass("container--centered");
					}
                });

                // Wrap any submodules in a full width row in a page container
                //$(" > .column.col-md-12 > div > section:not(.pageHero, .eventHero) div[class$='__container']", this).each(function () {
                //    $(this).addClass("container--centered");
                //});
				});
			
        }
    }
}